<section *ngIf="processes.length > 0" class="process-queue" [class.process-queue--expanded]="expanded">
	<button type="button" class="process-queue__header" (click)="toggle()" [attr.aria-expanded]="expanded">
		<span>
			Procesos en cola
			<span class="process-queue__badge">{{ processes.length }}</span>
		</span>
		<i class="fas" [ngClass]="expanded ? 'fa-chevron-down' : 'fa-chevron-up'" aria-hidden="true"></i>
	</button>

	<div class="process-queue__body" *ngIf="expanded">
		<article class="process-queue__item" *ngFor="let process of processes">
			<div class="process-queue__icon" aria-hidden="true">
				<span *ngIf="isProcessing(process.estado)" class="spinner-border spinner-border-sm text-primary"></span>
				<i *ngIf="isPending(process.estado)" class="far fa-clock text-muted"></i>
				<i *ngIf="isCompleted(process.estado)" class="fas fa-check-circle text-success"></i>
				<i *ngIf="isError(process.estado)" class="fas fa-exclamation-circle text-danger"></i>
			</div>

			<div class="process-queue__content">
				<div class="process-queue__name">{{ process.nombre }}</div>
				<div class="process-queue__progress" *ngIf="process.totalItems > 0">
					{{ process.itemsProcesados }} de {{ process.totalItems }} períodos
				</div>
				<div class="process-queue__message" *ngIf="isError(process.estado) && process.mensaje">
					{{ process.mensaje }}
				</div>
				<button
					*ngIf="process.puedeReintentar"
					type="button"
					class="btn btn-link btn-sm process-queue__retry"
					[disabled]="retrying.has(process.id)"
					(click)="retry(process, $event)"
				>
					{{ retrying.has(process.id) ? "Reintentando..." : "Reintentar" }}
				</button>
			</div>
		</article>
	</div>
</section>
